const DJB2_SEED = 5381;

export const getMonogram = (
  name: string,
  paletteSize: number,
): { letter: string; colorIndex: number } => {
  const key = name.trim();
  const letter = (Array.from(key)[0] ?? '').toUpperCase();
  const hash = Array.from(key.toLowerCase()).reduce(
    (acc, char) => ((acc << 5) + acc + (char.codePointAt(0) ?? 0)) >>> 0,
    DJB2_SEED,
  );

  return { letter, colorIndex: hash % paletteSize };
};
